import { render, staticRenderFns } from "./CaseDetailPage.vue?vue&type=template&id=f93d6be4&scoped=true"
import script from "./CaseDetailPage.vue?vue&type=script&lang=js"
export * from "./CaseDetailPage.vue?vue&type=script&lang=js"
import style0 from "./CaseDetailPage.vue?vue&type=style&index=0&id=f93d6be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93d6be4",
  null
  
)

export default component.exports